import { useNavigate } from "react-router-dom"
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LiveTvIcon from '@mui/icons-material/LiveTv';
import LogoutIcon from '@mui/icons-material/Logout';
import { useIsMobile } from "./context/MobileContext";
import { useAuth } from "./context/AuthProvider";

export function Menu(){
    
    const navigate = useNavigate()
    const {logout, user} = useAuth()
    
    return(
        <div style={{position:'absolute', top:'0', padding:'10px', cursor:'pointer'}}>
            <div style={{color:"#fff", float:'left'}}>
                <AccountCircleIcon style={{transform:'scale(1.2)'}} onClick={()=>{navigate('/login')}}/>
            </div>
            <div style={{color:"#fff", float:'left', marginLeft:'20px', cursor:'pointer'}}>
                <LiveTvIcon style={{transform:'scale(1.2)'}} onClick={()=>{navigate('/videos')}}/>
            </div>
            {user!=null&&(
                <div style={{color:"#fff", float:'left', marginLeft:'20px', cursor:'pointer'}}>
                    <LogoutIcon style={{transform:'scale(1.2)'}} onClick={logout}/>
                </div>
            )}
            <div style={{clear:'both'}}/>
        </div>
    )
}